import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import PanduanCard from 'app/GNNPage/components/PanduanCard'
import Section from 'app/GNNPage/components/Section'
import {
  ARTICLE_CARDS,
  KEGIATAN_GNN_CARDS,
  NEWS_CARDS,
  PANDUAN_GNN_CARDS,
} from 'app/GNNPage/data/cards'
import InfoCard from 'app/GNNPage/components/InfoCard'
import ArticleCard from 'app/GNNPage/components/ArticleCard'

const SumberBelajarPage = () => {
  return (
    <main>
      <Section title="Pedoman GNN">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {PANDUAN_GNN_CARDS.map((props, idx) => (
            <PanduanCard key={idx} {...props} />
          ))}
        </div>
      </Section>
      <Section title="Kegiatan Gerakan Numerasi Nasional">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {KEGIATAN_GNN_CARDS.map((detail, idx) => (
            <InfoCard
              key={idx}
              className="text-left"
              button={
                <Button
                  size="sm"
                  fullWidth
                  onClick={() => {
                    window.open(detail.button.url, '_blank')?.focus()
                  }}
                >
                  {detail.button.text}
                </Button>
              }
              content={
                <Text variant="body-sm" color="subdued" className="mb-5">
                  {detail.text}
                </Text>
              }
              icon={detail.icon}
              title={detail.title}
            />
          ))}
        </div>
      </Section>
      <Section title="Berita Numerasi">
        <Text variant="body-lg" color="subdued" className="mb-10 text-center">
          Berita terkini tentang perkembangan numerasi di Indonesia
        </Text>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {NEWS_CARDS.map((props, idx) => (
            <ArticleCard
              key={idx}
              imgUrl={`/images/gnn/berita/${idx + 1}.jpg`}
              {...props}
            />
          ))}
        </div>
      </Section>
      <Section title="Artikel Numerasi">
        <Text variant="body-lg" color="subdued" className="mb-10 text-center">
          Artikel mendalam tentang perkembangan numerasi di Indonesia
        </Text>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {ARTICLE_CARDS.map((props, idx) => (
            <ArticleCard
              key={idx}
              imgUrl={`/images/gnn/artikel/${idx + 1}.jpg`}
              {...props}
            />
          ))}
        </div>
        <div className="flex flex-col justify-center space-y-2 text-center mt-16">
          <Text variant="body-bold">
            Baca dan pahami berbagai artikel lainnya di Ide Praktik Numerasi
          </Text>
          <Button
            color="white"
            className="!bg-yellow-400 hover:!bg-yellow-500 w-fit mx-auto !mt-6"
            onClick={() => {
              window.open('/ide-praktik/kategori/numerasi', '_blank')?.focus()
            }}
          >
            Lihat Ide Praktik Numerasi
          </Button>
        </div>
      </Section>
      <Section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800">
        <Text
          as="h2"
          className="mb-5 text-center"
          color="inverse"
          variant="display-lg"
        >
          Data Numerasi Nasional
        </Text>
        <Text
          variant="body-lg"
          color="inverse-subdued"
          className="mb-10 text-center max-w-4xl mx-auto"
        >
          Akses data dan statistik terkini tentang kondisi numerasi di Indonesia
          melalui Rapor Pendidikan dan hasil Asesmen Nasional sebagai inspirasi
          berbasis data dalam merencanakan implementasi Gerakan Numerasi
          Nasional.
        </Text>
        <Button
          color="white"
          className="!bg-yellow-400 hover:!bg-yellow-500 w-fit mx-auto !mt-8 !outline-yellow-400 hover:!outline-yellow-500"
          onClick={() => {
            window
              .open(
                'https://data.kemendikdasmen.go.id/dataset/pendidikan-2/asesmen-nasional-and-rapor-pendidikan-2'
              )
              ?.focus()
          }}
        >
          Data Rapor Pendidikan & Asesmen Nasional
        </Button>
      </Section>
    </main>
  )
}

export default SumberBelajarPage
